import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'
import ShieldIcon from '@mui/icons-material/Shield'
import { Box, Button, Container, Typography } from '@mui/material'
import useProtectedPage from 'src/hooks/useProtectedPage'
import ActivityHistory from 'src/components/SideMenuAudit/ActivityHistory'
import { AlertComponent } from 'src/components/Alert/AlertComponent'
import { getPermissions } from 'src/service/authService'
import { goToCreateRole } from '../../routes/coordinator'
import RoleTable from './components/Table/RoleTable'

const Role = () => {
  useProtectedPage()
  const history = useNavigate()
  const { t } = useTranslation()
  const permissions = JSON.parse(getPermissions())

  return (
    <Container
      sx={{
        mt: '96px',
      }}
    >
      <AlertComponent />
      <Box
        component="div"
        sx={{
          color: '#FF5E1E',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '24px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <ShieldIcon />
          <Typography
            variant="h6"
            sx={{
              fontWeight: '500',
              fontSize: '20px',
              lineHeight: '160%',
              letterSpacing: ' 0.15px',
              color: ' #FF5E1E',
              marginTop: '-4px',
            }}
          >
            {t('role.title')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <ActivityHistory path="papeis" keySubtitle="roleName" />
        </Box>
      </Box>

      <Button
        onClick={() => goToCreateRole(history)}
        disabled={!permissions?.role?.includes("role:create")}
        variant="outlined"
        sx={{
          width: '50%',
          gap: '6px',
          height: '36px',
          mb: '40px',
          ':hover': {
            backgroundColor: '#FF5E1E',
            color: '#ffff',
          },
        }}
      >
        <AddIcon /> {t('role.button.create')}
      </Button>

      <RoleTable />
    </Container>
  )
}
export default Role
